import { AuthInfo } from '@provider/api/typing'
import { Auth } from '@provider/context/AuthContext/index'

const parseAccess = (msadGroups: string | string[]): string[] => {
  if (msadGroups && typeof msadGroups === 'string') {
    return [msadGroups]
  } else {
    return (msadGroups || []) as string[]
  }
}
/**
 * remove ['msad_groups', 'jti', 'acr', 'aud', 'iss', 'pi.sri'] from
 * @param data
 */
export const mapResponseAuth = (data: AuthInfo): Auth => ({
  access: parseAccess(data.msad_groups),
  displayName: data.displayName,
  email: data.email,
  exp: data.exp,
  expires_in: data.expires_in,
  sub: data.sub,
  refresh_token: data.refresh_token,
  token_fetched_at: Date.now(),
})
